import React from 'react'

function HeaderExtra() {
  return (
    <div className="MainTopButtonWrapper TopCornerButtonContainerScrolled SmallerShadow">
      <div className="TopMenuPanel" id="TopCornerButtonContainer">
        <div className="TopBackgroundThatWillChange"></div>
          <div className="TopMenuSectionWrapper" style={{display: "flex"}} id="TopMenuMainWrapper">
            <div className='TopUIGap' style={{margin: 'auto 0', display: 'flex'}}>
              <a href="/">
                <img className="PinginGoLogo Selectable2" src={process.env.PUBLIC_URL + "/Assets/images/Icon/pingingo-icon.svg"}/>
              </a>
              <button className='BasicUIButton BasicRadius BlueButton Selectable'>
                <p className='InterMediumTextFont HideOnMobile'>OTA Management Service</p>
                <p className='InterMediumTextFont ShowOnMobile'>OTA Management</p>
              </button>
            </div>
            <div className='TopUIGap' style={{margin: 'auto 0', marginLeft: 'auto', display: 'flex'}}>
              <div className='UserTopInfoWrapper' id='LanguageChangeTopMenu'>
                <div className="TopCircleImageContainer BasicThinGreyBorder2 Selectable2" style={{margin:'auto 0'}}>
                  <img className="ImageFullCover" src={process.env.PUBLIC_URL + "/Assets/images/CountryCode/Indonesia.svg"}/>
                </div>
                {/* <div class="ContainerFlex ContainerFlex2" id="TopLangDropDownContainer">
                  <div class="DropDownContainer HideScrollBar" style={{maxHeight: "none", right: "0px"}}>
                    <button class="DropDownSelectionContainer DropDownSelectionContainerSelected ColumnGapBasic Selectable4" >
                      <img class="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/CountryCode/Indonesia.svg"}/>
                      <p class="MidSizeText3 DropDownSelectionText">Bahasa Indonesia</p>
                    </button>
                    <button class="DropDownSelectionContainer Selectable4 ColumnGapBasic">
                      <img class="BigSizeIcon" src={process.env.PUBLIC_URL + "/Assets/images/CountryCode/UnitedKingdom.svg"}/>
                      <p class="MidSizeText3 DropDownSelectionText">English</p>
                    </button>
                  </div>
                </div> */}
              </div>
              <a className='BasicUIButton BasicRadius WhiteAndBlueButton Selectable2 ContactUsHref'>
                <img src={process.env.PUBLIC_URL + "/Assets/images/ButtonIcon/help-center.svg"}/>
                <p className='InterMediumTextFont HideOnMobile' id='HelpCenterBtnText'>Help Center</p>
                <p className='InterMediumTextFont ShowOnMobile' id='HelpCenterBtnMobileText'>Help</p>
              </a>
              <button className='BasicUIButton BasicRadius OrangeButton Selectable' id='PropertyAuditButton'>
                <p className='InterMediumTextFont HideOnMobile' id='PropertyAuditText'>Free 15-Minute Property Audit</p>
                <p className='InterMediumTextFont ShowOnMobile' id='PropertyAuditMobileText'>Property Audit</p>
              </button>
            </div>
          </div>
        </div>
    </div>
  )
}

export default HeaderExtra